import React, {Fragment} from 'react';
import {useNavigate} from 'react-router-dom';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MoreIcon from '@mui/icons-material/MoreVert';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import HomeIcon from '@mui/icons-material/Home';
import MailIcon from '@mui/icons-material/Mail';
import GroupIcon from '@mui/icons-material/Group';
import MailLockIcon from '@mui/icons-material/MailLock';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import AddToQueueIcon from '@mui/icons-material/AddToQueue';

import {auth} from '../../firebase';
import {signOut} from 'firebase/auth';
import {ListItem} from '@mui/material';

const NavBar = () => {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [
    mobileMoreAnchorEl,
    setMobileMoreAnchorEl,
  ] = React.useState<null | HTMLElement>(null);
  const [openDrawer, setOpenDrawer] = React.useState<boolean>(false);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleSignOut = () => {
    signOut(auth);
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleSignOut}>Sair</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleProfileMenuOpen}>
        {auth?.currentUser?.email ?? ''}
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Meu perfil</p>
      </MenuItem>
    </Menu>
  );


  return (
    <Box
      sx={{flexGrow: 1}}
      style={{
        paddingBottom: 20,
      }}
    >
      <AppBar position="static">
        <Toolbar>
          <Fragment>
            <IconButton
              size="small"
              edge="start"
              color="inherit"
              aria-label="open drawer"
              sx={{mr: 2}}
              onClick={() => setOpenDrawer(true)}
            >
              Menu
              <MenuIcon fontSize='small'/>
            </IconButton>
            <SwipeableDrawer
              open={openDrawer}
              onClose={() => setOpenDrawer(false)}
              onOpen={() => setOpenDrawer(true)}
            >
              <Box
                sx={{width: 'auto'}}
                role="presentation"
              >
                <List>
                  <ListItemButton>
                    <ListItemIcon>
                      <HomeIcon/>
                    </ListItemIcon>
                    <ListItemText
                      primary={'Home'}
                      onClick={() => {
                        navigate('/home');
                        setOpenDrawer(false);
                      }}
                    />
                  </ListItemButton>
                  <List>
                    <ListItem>
                      <ListItemIcon>
                        <AddToQueueIcon />
                      </ListItemIcon>
                      <ListItemText primary="Telemedicina" />
                    </ListItem>
                    <List component="div" disablePadding>
                      <ListItemButton sx={{pl: 4}}>
                        <ListItemIcon>
                          <RequestQuoteIcon/>
                        </ListItemIcon>
                        <ListItemText
                          primary={'Cobrança'}
                          onClick={() => {
                            navigate('/telemedicine/charges');
                            setOpenDrawer(false);
                          }}
                        />
                      </ListItemButton>
                      <ListItemButton sx={{pl: 4}}>
                        <ListItemIcon>
                          <MoveToInboxIcon/>
                        </ListItemIcon>
                        <ListItemText
                          primary={'Criar Release'}
                          onClick={() => {
                            navigate('/telemedicine/releases/creation');
                            setOpenDrawer(false);
                          }}
                        />
                      </ListItemButton>
                      <ListItemButton sx={{pl: 4}}>
                        <ListItemIcon>
                          <MailLockIcon/>
                        </ListItemIcon>
                        <ListItemText
                          primary={'Releases'}
                          onClick={() => {
                            navigate('/telemedicine/releases');
                            setOpenDrawer(false);
                          }}
                        />
                      </ListItemButton>
                      <ListItemButton sx={{pl: 4}}>
                        <ListItemIcon>
                          <MailIcon/>
                        </ListItemIcon>
                        <ListItemText
                          primary={'Releases Públicos'}
                          onClick={() => {
                            navigate('/telemedicine/releases/public');
                            setOpenDrawer(false);
                          }}
                        />
                      </ListItemButton>
                      <ListItemButton sx={{pl: 4}}>
                        <ListItemIcon>
                          <GroupIcon/>
                        </ListItemIcon>
                        <ListItemText
                          primary={'Emails dos releases dos clientes'}
                          onClick={() => {
                            navigate('/telemedicine/releases/registeredEmails');
                            setOpenDrawer(false);
                          }}
                        />
                      </ListItemButton>
                    </List>
                  </List>

                  <List>
                    <ListItem>
                      <ListItemIcon>
                        <CloudQueueIcon />
                      </ListItemIcon>
                      <ListItemText primary="PACS" />
                    </ListItem>
                    <List component="div" disablePadding>
                      <ListItemButton sx={{pl: 4}}>
                        <ListItemIcon>
                          <RequestQuoteIcon/>
                        </ListItemIcon>
                        <ListItemText
                          primary={'Cobrança'}
                          onClick={() => {
                            navigate('/pacs/charges');
                            setOpenDrawer(false);
                          }}
                        />
                      </ListItemButton>
                    </List>
                  </List>
                </List>
              </Box>
            </SwipeableDrawer>
          </Fragment>
          <Box sx={{flexGrow: 1}} />
          {auth?.currentUser?.email ?? ''}
          <Box sx={{display: {xs: 'none', md: 'flex'}}}>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
          </Box>
          <Box sx={{display: {xs: 'flex', md: 'none'}}}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </Box>
  );
};

export default NavBar;
